import { useState } from "react";
import { NavLink } from "react-router-dom";

export function Nav(props) {
  const [items] = useState([
    {
      name: "Invoice List",
      to: "invoice-list",
    },
    {
      name: "Customer List",
      to: "customer-list",
    },
    {
      name: "Inventory",
      to: "inventory",
    },
    {
      name: "Manage Transaction",
      to: "manage-transaction",
    },
  ]);

  return (
    <div className="dashboard-tabs innerpage-tabs px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
